import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { FileText, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const LABELS = { relazione_tecnica: "Relazione tecnica", piano_economico: "Piano economico-finanziario", indennizzo: "Stima indennizzo", accessibilita: "Relazione accessibilità", sostenibilita_esg: "Relazione di sostenibilità ESG", piano_servizi: "Piano dei servizi", clausole_sociali: "Clausole sociali", amministrativa: "Guida documentazione amministrativa", custom: "Elaborato personalizzato" };
const testo = (v) => (typeof v === "string" ? v : v?.testo || "");

export function SezioniSalvate({ pratica, onSaved }) {
  const sezioni = Object.entries(pratica.sezioni || {}).filter(([, v]) => testo(v)).map(([k, v]) => [k, testo(v), typeof v === "object" ? v.updated_at : null]);
  const [editing, setEditing] = useState(null);
  const [text, setText] = useState("");

  const save = async (key, value) => {
    try { const { data } = await api.patch(`/pratiche/${pratica.id}`, { sezioni: { ...pratica.sezioni, [key]: value } }); onSaved(data); setEditing(null); toast.success("Elaborato aggiornato"); } catch (err) { toast.error(formatApiError(err)); }
  };

  if (sezioni.length === 0) return (
    <div className="bg-white border border-dashed border-slate-300 rounded-xl p-12 text-center" data-testid="sezioni-empty">
      <div className="mx-auto h-12 w-12 rounded-full border-2 border-dashed border-slate-300 flex items-center justify-center text-slate-400"><FileText strokeWidth={1.5} /></div>
      <p className="text-sm text-slate-600 mt-4">Nessun elaborato salvato. Genera una bozza con l'Assistente AI e premi «Salva».</p>
    </div>
  );

  return (
    <div className="space-y-4" data-testid="sezioni-list">
      {sezioni.map(([k, v, upd]) => (
        <div key={k} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`sezione-${k}`}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-heading font-medium text-slate-900">{LABELS[k] || k}{upd && <span className="ml-2 text-xs font-normal text-slate-400">aggiornato il {upd.slice(0, 10)}</span>}</h3>
            <div className="flex gap-1">
              <Button size="sm" variant="outline" onClick={() => { setEditing(k); setText(v); }} data-testid={`sezione-edit-${k}`}>Modifica</Button>
              <Button size="sm" variant="ghost" className="text-slate-400 hover:text-red-600" onClick={() => save(k, "")} data-testid={`sezione-delete-${k}`}><Trash2 size={14} /></Button>
            </div>
          </div>
          {editing === k ? (
            <div>
              <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={16} className="bg-slate-50 font-mono text-xs" data-testid={`sezione-textarea-${k}`} />
              <div className="flex gap-2 mt-2"><Button size="sm" onClick={() => save(k, text)} className="bg-[#003087]" data-testid={`sezione-save-${k}`}>Salva</Button><Button size="sm" variant="ghost" onClick={() => setEditing(null)}>Annulla</Button></div>
            </div>
          ) : <div className="prose-ai text-sm max-h-[480px] overflow-y-auto"><ReactMarkdown>{v}</ReactMarkdown></div>}
        </div>
      ))}
    </div>
  );
}
